import { FileDropZoneSkeleton } from '@/components/documents/FileDropZoneSkeleton'
import { Skeleton } from '@/components/ui/skeleton'

export function DocumentRequirementCardSkeleton() {
  return (
    <div className="rounded-2xl border border-border/60 bg-white p-5 shadow-[0_2px_16px_rgba(0,0,0,0.04)]">
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <Skeleton className="h-10 w-10 shrink-0 rounded-xl" />
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-3 w-full max-w-md" />
          </div>
        </div>
        <FileDropZoneSkeleton />
      </div>
    </div>
  )
}
